import { useNavigate } from "react-router-dom"
import useHome from "./useHome"
import "./home_style.css"
import AvatarDropdown from "../../components/avatar"
import swal from "sweetalert"

const HomePage = () => {
    const navigate = useNavigate()
    const {
        apps,
        setKeyword,
    } = useHome()
    return (
        <div className="home-wrapper">
            <div className="col-lg-12">
                <h1 className="d-flex justify-content-center mb-4 title-home">E-Office Web App</h1>
                <div className="d-flex justify-content-center mb-4">

                    <input
                        name="search"
                        type="text"
                        className="form-control"
                        placeholder="Search App..."
                        onChange={(e) => setKeyword(e.target.value.toLowerCase())}
                        style={{
                            fontSize: "16px",
                            padding: "16px",
                            borderRadius: "100px 0px 0px 100px",
                            maxWidth: "1000px"
                        }}
                    />
                    <button type="button" className="btn btn-outline-info p-3" style={{
                        borderRadius: "0px 100px 100px 0px",
                        marginRight: "1rem"
                    }}><i className="bi bi-search"></i></button>
                    <AvatarDropdown />
                </div>
                <div className="col-lg-12 card-home">
                    <div className="row d-flex justify-content-center">
                        {
                            apps && apps.map((data, index) => (
                                <div
                                    key={index}
                                    style={{ cursor: "pointer" }}
                                    className="col-lg-4 col-md-6 col-sm-12"
                                    onClick={() => {
                                        if (data.title === "TTE") {
                                            swal("Info", "Halaman sedang dipersiapkan", "info")
                                            return
                                        }

                                        window.location.href = data.url
                                    }}
                                >
                                    <div className="card mb-4">
                                        <img
                                            src={data.image}
                                            className="card-img-top"
                                            style={{
                                                height: "250px",
                                                objectFit: "cover"
                                            }}
                                        />
                                        <div className="card-body">
                                            <h5 className="card-title" style={{ fontSize: "36px" }}>{data.title}</h5>
                                            <p className="card-text">{data.description}</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
            <hr />
            <div className="footer-home">
                <div className="copyright-home">
                    &copy; Copyright <strong><span>E-Office Web App</span></strong> - All Rights Reserved
                </div>
                <div className="credits-home">
                    Designed by <a href="#">PUSDATIN</a>
                </div>
            </div>
        </div>
    )
}
export default HomePage